import Icon from "@ant-design/icons";
import { ReactComponent as InfluencersSvg } from "./svg/influencers.svg";

const InfluencersIcon = (props) => (
	<Icon component={InfluencersSvg} {...props} />
);

export default InfluencersIcon;
